import React from "react";
import PropTypes from "prop-types";
import { Box, IconButton, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import DialogAnimate from "src/components/Animate/DialogAnimate";
import OnboardingWizardContent from "./OnboardingWizardContent";

// ----------------------------------------------------------------------
//
//   Modal del wizard onboarding (Fix3 · 2026-07-22). Se abre desde el
//   widget de TopBar o el card del dashboard — el user NO sale de la
//   vista principal, en vez de navegar a `/wizard` (que sigue existiendo
//   por compatibilidad post-registro).
//
// ----------------------------------------------------------------------

OnboardingWizardModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  /** Si true, el modal NO se puede cerrar (X oculta, escape/backdrop no
   * cierran). Se usa para users nuevos que aún no tienen mesas — es
   * obligatorio completar el wizard antes de trabajar. */
  mandatory: PropTypes.bool,
};

export default function OnboardingWizardModal({ open, onClose, mandatory = false }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <DialogAnimate
      open={open}
      // Si es obligatorio, ignoramos el cierre por backdrop/escape del
      // DialogAnimate — solo se cierra cuando el user completa el
      // último step (que llama a onClose desde dentro del content).
      onClose={mandatory ? undefined : onClose}
      maxWidth="lg"
      fullScreen={isMobile}
      fullWidth
    >
      <Box sx={{ position: "relative" }}>
        {!mandatory && (
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              zIndex: 2,
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
        <OnboardingWizardContent onClose={onClose} mandatory={mandatory} />
      </Box>
    </DialogAnimate>
  );
}
